import { baseEnglishTexts } from './english'

const baseTranslationTexts = { ...baseEnglishTexts }

export const getLocale = (defaults) => {
  if (window.translations) return { ...baseTranslationTexts, ...defaults, ...window.translations }

  return { ...baseTranslationTexts, ...defaults }
}

export const getBoldTexts = (text) => {
  return text.split('<bold>').map((t, i) => {
    return { text: t, bold: i % 2 !== 0 }
  })
}

